export default __webpack_public_path__ + "static/media/rgs_medium.02c91073.jpg";